import _objectSpread from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.push.js";
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import certificateDetail from '../compontent/certificate-detail';
export default {
  components: {
    certificateDetail: certificateDetail
  },
  computed: _objectSpread(_objectSpread({}, mapState({
    // 产品套餐 ----> '1'基础 '2'高级 '3'老用户
    product_package: function product_package(state) {
      return state.user.company_info.product_package;
    }
  })), {}, {
    officialData: function officialData() {
      var _this = this;
      return this.officialDataConfig.map(function (item) {
        item.list = item.list.filter(function (cItem) {
          return cItem.permission ? cItem.permission.includes(_this.product_package) : true;
        });
        return item;
      });
    }
  }),
  data: function data() {
    return {
      officialDataConfig: [
      // 列表配置数据
      {
        list: [{
          // 在职证明
          icon: require('@/assets/img/icon-staff1.png'),
          name: this.$t('certificate_staff_1'),
          // 模块名称
          txt: this.$t('certificate_staff_2'),
          // 模块介绍
          path: '/certificate/detail-staff/1',
          // 页面对应路径
          goPath: '/certificate/staff' // 返回路径
        }, {
          // 工资证明
          icon: require('@/assets/img/icon-staff2.png'),
          name: this.$t('certificate_staff_3'),
          txt: this.$t('certificate_staff_4'),
          path: '/certificate/detail-staff/2',
          goPath: '/certificate/staff',
          permission: ['2', '3'] // 高级套餐和老用户显示
        }, {
          // 就业证明
          icon: require('@/assets/img/icon-staff3.png'),
          name: this.$t('certificate_staff_5'),
          txt: this.$t('certificate_staff_6'),
          path: '/certificate/detail-staff/3',
          goPath: '/certificate/staff'
        }, {
          // 50 tawi
          icon: require('@/assets/img/icon-staff4.png'),
          name: this.$t('certificate_staff_7'),
          txt: this.$t('certificate_staff_8'),
          path: '/certificate/detail-staff/4',
          goPath: '/certificate/staff',
          permission: ['2', '3'] // 高级套餐和老用户显示
        }]
      }],

      but: {
        history: {
          label: this.$t('certificate_staff_9'),
          path: '/certificate/history-staff',
          goPath: '/certificate/staff'
        },
        timing: {
          label: this.$t('certificate_staff_10'),
          path: '/certificate/timing-staff',
          goPath: '/certificate/staff'
        }
      },
      authority: {
        export: this.$p('menu.certificate.staff.export'),
        edit: this.$p('menu.certificate.staff.edit')
      },
      itemData: {
        cItem: {}
      }
    };
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    to.meta.title = this.itemData.cItem.name || to.meta.title;
    next();
  },
  methods: {
    handleItem: function handleItem(item) {
      this.itemData = item;
      this.$router.push(item.cItem.path);
    }
  }
};